module.exports = __webpack_public_path__ + "static/konfor-web-c245f28cc5975b4b6e7e74ceec2faa00.jpg";